import { WritableSignal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { matchSsns } from 'src/app/utils/validations/field-rules';

export function createConfirmSsnForm(fb: UntypedFormBuilder): UntypedFormGroup {
  return fb.group({
    ssn: ['', [Validators.pattern('^[0-9]*$'), Validators.minLength(9), Validators.maxLength(9), Validators.required]],
    confirmSsn: ['', [Validators.pattern('^[0-9]*$'), matchSsns('ssn', 'confirmSsn'), Validators.minLength(9), Validators.maxLength(9), Validators.required]]
  });
}

export function isCopyShortcut(event: KeyboardEvent): boolean {
  return (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'c';
}

export function restartVisibilityTimer(
  visibleSignal: WritableSignal<boolean>,
  activeTimer: number | null,
  onTimerCleared: () => void,
  timeoutMs = 5000
): number {
  visibleSignal.set(true);
  clearVisibilityTimer(activeTimer);
  return window.setTimeout(() => {
    visibleSignal.set(false);
    onTimerCleared();
  }, timeoutMs);
}

export function clearVisibilityTimer(activeTimer: number | null): null {
  if (activeTimer) {
    window.clearTimeout(activeTimer);
  }

  return null;
}
